import { render } from "./Gallery.vue?vue&type=template&id=d96dc79a"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Gallery/Gallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d96dc79a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d96dc79a', __exports__)) {
    api.reload('d96dc79a', __exports__)
  }
  
  module.hot.accept("./Gallery.vue?vue&type=template&id=d96dc79a", () => {
    api.rerender('d96dc79a', render)
  })

}


export default __exports__